import React, { useState } from 'react';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import ImageCard from './ImageCard';
function getModalStyle() {
  const top = 35;
  const left = 35;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 1000,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    height: '750px',
  },
}));

const PreviewPopup = (props) => {
  const {
    handleClose,
    viewPreviewStatus,
    title,
    subTitle1,
    subTitle2,
    children,
    topAppointment,
    count,
    revenue,
  } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='analytic-header-wrapper row d-flex'>
        <div className='col-md-7'>
          <span className='analytic-title'>{title}</span>
        </div>
        <div className='col-md-5 d-flex justify-content-end'>
          <>
            <img
              className='mt-1 ms-1 me-4 analytic-refresh-icon'
              src={'./assets/icons/dashboard/close.svg'}
              alt={'completed'}
              onClick={handleClose}
            />
          </>
        </div>
      </div>
      <div className='analytic-breaker' />
      <div className='mt-4 analytic-popup-sub-1'>{subTitle1}</div>
      <div className='d-flex justify-content-around analytic-popup-table-wrapper'>
        {topAppointment?.map((img, i) => (
          <ImageCard
            key={i + 1}
            title={img.name}
            count={i + 1}
            subTitle1={img.sub1}
            subTitle2={img.sub2}
            url={img.img}
          />
        ))}

        <div className='total-booking-preview me-4 ms-1'>
          <span>{count}</span>
          <span className='total-title ms-1'>Total Count</span>
        </div>
        {revenue !== 'NA' && (
          <div className='total-booking2-preview me-4 ms-1'>
            <span>{revenue}</span>
            <span className='total-title'> Total Revenue</span>
          </div>
        )}
      </div>
      <div className='analytic-breaker-light-2 mb-4' />
      <div className='mt-2 analytic-popup-sub-1'>{subTitle2}</div>

      <div className='analytic-popup-table-wrapper analytic-popup-table-vertical-scrolling'>
        {children}
      </div>
    </div>
  );
  return (
    <div>
      <Modal open={viewPreviewStatus} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default PreviewPopup;
